// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__-jJVN","options":"AnswerScale_options__1YsN_","selected":"AnswerScale_selected__DSELW"};